<template>
  <div class="calendar-chips">
    <div v-if="title" class="calendar-chips__title">{{ title }}</div>
    <div class="calendar-chips__item"
         style="margin-top: 0 !important;"
         v-for="option in options"
         :key="option.value"
         :class="[{'calendar-chips_selected': isSelected(option), 'calendar-chips_not-selected': !isSelected(option),
         'calendar-chips_disabled': isDisabled(option.value)}, option.className]"
         @click.stop="onOptionSelected(option)">
      <span class="calendar-chips__name" :style="{color: option.className.color}">{{option.label}}</span>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Calendar from './index'

export default {
  name: 'CalendarChips',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    filteredOptions: {
      type: Object,
      default: () => {}
    },
    // array of default values, if includes 'all', select all options
    predefinedValue: {
      type: Array,
      default: () => ['all']
    }
  },
  data () {
    return {
      selectedOptions: [],
      previousFilteredOptions: []
    }
  },
  watch: {
    /**
     * callback invoked by changing filteredTypes from {@link Calendar}
     * this way the component is notified about actually shown event types
     */
    filteredOptions: {
      handler (value) {
        const types = value.types || []
        if (value.filterAction === 'reset') {
          this.previousFilteredOptions = types
          this.selectedOptions = []
          if (this.predefinedValue.includes('all')) {
            this.selectedOptions.push(...this.options.map(item => item.value))
            this.$emit('change', this.selectedOptions)
          } else if (!this.predefinedValue.includes('none')) {
            this.selectedOptions = [...this.predefinedValue]
            this.$emit('change', this.selectedOptions)
          } else {
            this.$emit('noFilters')
          }
        }
      },
      deep: true
    }
  },
  methods: {
    onOptionSelected (option) {
      const index = this.selectedOptions.findIndex(value => value === option.value)
      if (~index) {
        this.selectedOptions.splice(index, 1)
      } else {
        this.selectedOptions.push(option.value)
      }
      this.$emit('change', this.selectedOptions)
    },
    /**
     *  methods {@link #isSelected} and {@link #isDisabled} manage class of specific item in dropdown
     *  pay attention - if classes are applied simultaneously the class with bigger priority wins.
     *  In our case - class that placed in style sheet lower ('calendar-chips__item_disabled' in this component)
     * @param option
     * @returns {boolean|default.computed.allSelected|(function(): boolean)}
     */
    isSelected (option) {
      return this.selectedOptions.includes(option.value)
    },
    isDisabled (optionId) {
      return this.filteredOptions.types && !this.filteredOptions.types.includes(optionId)
    }
  }

}
</script>

<style scoped lang="scss">
  .calendar-chips {
    display: flex;
    align-items: center;
    padding-right: 12px;
    border-right: 1px solid #dbdee5;

    &__item {
      padding: 8px 10px;
      border-radius: 15px;
      border: 1px solid #dbdee5;
      height: 30px !important;
      margin-top: 0 !important;
      margin-right: 12px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $rfx-dark-march;
      cursor: pointer;
      width: 85px;

      &:hover {
        color: $rfx-dark-cyan;
        border-color: currentColor;
      }

    }

    &_not-selected {
      color: $rfx-dark-march!important;
      border-color: #dbdee5 !important;
      background-color: transparent!important;
    }

    &_selected {
      color: currentColor;
      border-color: currentColor;
      background-color: $rfx-light-cyan;
    }

    &_disabled {
      pointer-events: none;
      color: #dbdee5 !important;
      border: solid 1px #dbdee5 !important;
      background-color: transparent !important;
    }

    &__title {
      font-size: 12px;
      color: $rfx-dark-march;
      margin-right: 12px;
      margin-left: 24px;
      line-height: 16px;
    }

    &__name {
      font-size: 12px;
      white-space: nowrap;
      user-select: none;

    }

    &_test {
      opacity: 0;
    }
  }
</style>
